import types from "./types";

export const toggleModal = (open) => {
  return {
    type: types.TOGGLE_MODAL,
    open,
  };
};
